import * as React from "react";
import { useTranslation } from "react-i18next";
import ProfileUserAttributes from "../../presentations/ProfileAttributes";

const ProfileAttributesContainer = () => {

  const { t } = useTranslation();

  return (
    <div>
      <div className="mb-2 font-semibold text-gray-700">
        {t("profileSummary.label.attributes")}
      </div>
      <div>
        <ProfileUserAttributes></ProfileUserAttributes>
      </div>
    </div>
  );
};

export default ProfileAttributesContainer;
